import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { orderApi } from "../../app/slices/orderSlice";
import { Box, LinearProgress } from "@mui/material";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI


export default function Order() {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(orderApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector((state) => state.order.order.data);
  const rawData = useSelector((state) => state.order.order.data);
  const stateLoading = useSelector((state) => state.order.loading);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 250,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.customerRefNo || cell.row.original?.client_id
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip
            title={
              cell.row.original?.customerRefNo || cell.row.original?.client_id
            }
          >
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo || cell.row.original?.client_id}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerUniqueId", {
      header: "Customer Unique ID",
      size: 200,
      Cell: (cell) =>
        cell.row.original?.customerDetails?.customerUniqueId ||
        cell.row.original?.productDetails?.[0]?.customerDetails
          ?.customerUniqueId,
    }),

    columnHelper.accessor("firstName", {
      header: "Name",
      size: 150,
      Cell: (cell) => {
        const cd = cell.row.original?.customerDetails;
        const pd = cell.row.original?.productDetails?.[0]?.customerDetails;

        const first = cd?.firstName || pd?.firstName || "";
        const last = cd?.lastName || pd?.lastName || "";
        return `${first} ${last}`.trim();
      }
      // Cell: (cell) =>
      //   `${cell.row.original?.customerDetails?.firstName || ""} ${
      //     cell.row.original?.customerDetails?.lastName || ""
      //   }` ||
      //   `${
      //     cell.row.original?.productDetails?.[0]?.customerDetails?.firstName ||
      //     ""
      //   } ${
      //     cell.row.original?.productDetails?.[0]?.customerDetails?.lastName ||
      //     ""
      //   }`,
    }),
    // column/
    columnHelper.accessor("mobileNumber", {
      header: "Mobile Number",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.customerDetails?.mobileNumber ||
        cell.row.original?.productDetails?.[0]?.customerDetails?.mobileNumber,
    }),
    columnHelper.accessor("email", {
      header: "Email",
      size: 250,
      Cell: (cell) =>
        cell.row.original?.customerDetails?.email ||
        cell.row.original?.productDetails?.[0]?.customerDetails?.email,
    }),

    columnHelper.accessor("orderid", {
      header: "Order ID",
      size: 200,
      Cell: (cell) =>
        cell.row.original?.MerchantOrder_id || cell.row.original?.orderid,
    }),
    columnHelper.accessor("orderUniqueId", {
      header: "Order Unique ID",
      size: 200,
      Cell: (cell) =>
        cell.row.original?.orderUniqueId ||
        cell.row.original?.productDetails?.[0]?.orderUniqueId ||
        "N/A",
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    // Product Details
    columnHelper.accessor("productId", {
      header: "Product ID",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.productId ||
        cell.row.original?.productDetails?.[0]?.id ||
        "N/A",
    }),
    columnHelper.accessor("productName", {
      header: "Product Name",
      size: 250,
      Cell: (cell) =>
        cell.row.original?.product?.productName ||
        cell.row.original?.productDetails?.[0]?.product?.productName,
    }),
    columnHelper.accessor("sku", {
      header: "SKU",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.product?.sku ||
        cell.row.original?.productDetails?.[0]?.product?.sku,
    }),
    columnHelper.accessor("weight", {
      header: "Weight (grams)",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.product?.weight ||
        cell.row.original?.productDetails?.[0]?.product?.weight,
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.metalType || cell.row.original?.metal_type,
    }),

    // Customer Information

    // Order Status and Payment
    columnHelper.accessor("status", {
      header: "Status",
      size: 150,
      Cell: (cell) => cell.row.original?.status,
    }),
    // columnHelper.accessor("orderStatusId", {
    //   header: "Order Status ID",
    //   size: 150,
    //   Cell: (cell) =>
    //     cell.row.original?.orderStatusId ||
    //     cell.row.original?.productDetails?.[0]?.orderStatusId ||
    //     "N/A",
    // }),
    // columnHelper.accessor("paymentTypeId", {
    //   header: "Payment Type ID",
    //   size: 150,
    //   Cell: (cell) =>
    //     cell.row.original?.paymentTypeId ||
    //     cell.row.original?.productDetails?.[0]?.paymentTypeId ||
    //     "N/A",
    // }),
    // columnHelper.accessor("paymentType", {
    //   header: "Payment Type",
    //   size: 150,
    //   Cell: (cell) =>
    //     cell.row.original?.paymentType?.paymentType ||
    //     cell.row.original?.productDetails?.[0]?.paymentType?.paymentType,
    // }),

    // Amounts
    columnHelper.accessor("finalOrderPrice", {
      header: "Final Order Price",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.orderdetails?.[0]?.finalOrderPrice ||
        cell.row.original?.productDetails?.[0]?.orderdetails?.[0]
          ?.finalOrderPrice ||
        "N/A",
    }),
    // columnHelper.accessor("initialPayment", {
    //   header: "Initial Payment",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.initialPayment,
    // }),
    // columnHelper.accessor("forwordCost", {
    //   header: "Forward Cost",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.forwordCost,
    // }),

    // Quantity and EMI
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 150,
      Cell: (cell) =>
        cell.row.original?.quantity ||
        cell.row.original?.productDetails?.[0]?.quantity ||
        "N/A",
    }),
    // columnHelper.accessor("numberOfPendingEmi", {
    //   header: "Number of Pending EMI",
    //   size: 200,
    //   Cell: (cell) =>
    //     cell.row.original?.numberOfPendingEmi ||
    //     cell.row.original?.productDetails?.[0]?.numberOfPendingEmi ||
    //     "0",
    // }),

    // Timestamps
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated Date",
      size: 150,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),

    // Additional Status
    columnHelper.accessor("augmont_status", {
      header: "Order Status",
      size: 200,
      Cell: (cell) => cell.row.original?.augmont_status,
    }),
    // columnHelper.accessor("is_deleted", {
    //   header: "Is Deleted",
    //   size: 150,
    //   Cell: (cell) => (cell.row.original?.is_deleted ? "Yes" : "No"),
    // }),
  ];


  const flatData = useMemo(() => {
    if (!rawData || !Array.isArray(rawData)) return [];

    return rawData.map(item => {
      const product = item.productDetails?.[0] || {};
      const productInfo = product.product || {};
      const customer = product.customerDetails || {};
      const order = product.orderdetails?.[0] || {};

      return {
        _id: item._id,
        transactionId: item.transactionId,

        metalType: item.metalType,
        status: item.status,
        augmont_status: item.augmont_status,
        mode: item.mode,

        productName: productInfo.productName,
        sku: productInfo.sku,
        weight: productInfo.weight,
        quantity: product.quantity,

        paymentType: product.paymentType?.paymentType,
        finalOrderPrice: order.finalOrderPrice,

        customerName: `${customer.firstName || ""} ${customer.lastName || ""}`,
        customerMobile: customer.mobileNumber,
        customerEmail: customer.email,
        panCardNumber: item.panCardNumber,

        shippingCity: item.shippingCityName,
        shippingState: item.shippingStateName,
        shippingPostalCode: item.shippingPostalCode,

        createdAt: new Date(item.createdAt).toLocaleString(),
      };
    });
  }, [rawData]);

  // const sliceResponse = flatData.slice(0, 10);
  // const DataForExportAll = flatData;


  return (
    <>
     {/*  */}
      <>
        <DateSearchComponent onSearch={handleSearch} />
        <Box mt={2}>
          <CustomTable
            columns={columns}
            data={sliceResponse}
            loading={stateLoading}
            DataForExportAll={flatData}
            permissionKey="Order"
          />
        </Box>
      </>
    </>
  );
}
